import { useState, React } from 'react';

import Table11 from './1.1';
// import Table11B from './1.1.B';
import Table12 from './1.2';
import Table13 from './1.3';
import Table21 from './2.1';
import Table22 from './2.2';
import Table23 from './2.3';
import Table24 from './2.4';
import Table25 from './2.5';
import Table31 from './3.1';
import Table32 from './3.2';

import { RemainingTimeContext } from './../../../context/TimerContext';

const Evaluation = ({ menu, childToParent }) => {
  const { selectedApas, currentMenuId } = menu;

  if (currentMenuId === '1.1')
    return (
      <>
        <Table11
          currentApas={selectedApas}
          menu={menu}
          tableNo={'1.1'}
          // tableNo={'1.1.A'}
          title="A~Teaching Evaluation"
          childToParent={childToParent}
        />
        {/* <br />
        <Table11B
          currentApas={selectedApas}
          menu={menu}
          tableNo={'1.1.B'}
          title="B~Supervision"
          childToParent={childToParent}
        /> */}
      </>
    );
  else if (currentMenuId === '1.2')
    return (
      <Table12
        currentApas={selectedApas}
        menu={menu}
        tableNo={'1.2'}
        // dataConverter={{
        //   toTableData: convertToTableData,
        //   toRequestData: convertToRequestData
        // }}
        hasReset={true}
        childToParent={childToParent}
      />
    );
  else if (currentMenuId === '1.3')
    return (
      <Table13
        currentApas={selectedApas}
        menu={menu}
        tableNo={'1.3'}
        hasReset={true}
        childToParent={childToParent}
      />
    );
  else if (currentMenuId === '2.1')
    return <Table21
      currentApas={selectedApas}
      menu={menu}
      tableNo={'2.1'}
      childToParent={childToParent}
    />;
  else if (currentMenuId === '2.2')
    return <Table22 currentApas={selectedApas} menu={menu} tableNo={'2.2'} childToParent={childToParent}
    />;
  else if (currentMenuId === '2.3')
    return <Table23 currentApas={selectedApas} menu={menu} tableNo={'2.3'} childToParent={childToParent}
    />;
  else if (currentMenuId === '2.4')
    return <Table24 currentApas={selectedApas} menu={menu} tableNo={'2.4'} childToParent={childToParent}
    />;
  else if (currentMenuId === '2.5')
    return <Table25 currentApas={selectedApas} menu={menu} tableNo={'2.5'} childToParent={childToParent}
    />;
  else if (currentMenuId === '3.1')
    return <Table31 currentApas={selectedApas} tableNo={'3.1'} childToParent={childToParent} menu={menu} />;
  else if (currentMenuId === '3.2')
    return <Table32 currentApas={selectedApas} tableNo={'3.2'} childToParent={childToParent} menu={menu} />;
  else return <div>Table Not Found</div>;
};

export const Evaluations = ({ menu, childToParent }) => {
  const [timer, setTimer] = useState(1000);

  return (
    <RemainingTimeContext.Provider value={{ timer, setTimer }}>
      <Evaluation menu={menu} childToParent={childToParent} />
    </RemainingTimeContext.Provider>
  );
};
